<div class="flex flex-col gap-4">
	<p>
		Are you sure you want to delete this note? This action cannot be undone.
	</p>
	<div class="flex justify-end gap-2">
		<ui-button
			preset="EXTRA_LOW_EMPHASIS"
			label="Cancel"
			(click)="onCancel()"
		></ui-button>
		<ui-button
			color="error"
			label="Yes, delete note"
			(click)="onDelete()"
		></ui-button>
	</div>
</div>
